import { ApolloClient, ApolloProvider, from, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useAuth0 } from '@auth0/auth0-react';
import { PropsWithChildren } from 'react';
import { getConfig } from '../utils/config.ts';
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename';
import { loginConfig } from '../utils/loginConfig';

export const GraphQlProvider = ({ children }: PropsWithChildren) => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();
  const { graphQlUrl } = getConfig();
  const httpLink = new HttpLink({ uri: graphQlUrl });
  const authLink = setContext(async (_, { headers }) => {
    let token = '';
    try {
      token = await getAccessTokenSilently();
    } catch {
      await loginWithRedirect(loginConfig(window.location.pathname));
      throw new Error('Not logged in. Redirecting...');
    }

    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      },
    };
  });
  const removeTypenameLink = removeTypenameFromVariables();
  const link = from([removeTypenameLink, authLink.concat(httpLink)]);
  const client = new ApolloClient({ link, cache: new InMemoryCache({ addTypename: false }) });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
